import { noop } from 'lodash';
import { memo } from 'react';

import { type Clip } from '@air/api/types';

import { DraggingOverlay } from '~/components/Gallery/DraggingOverlay';
import { DNDMovableToBoardItem } from '~/components/Shared/Drag/DNDMovableToBoardItem/DNDMovableToBoardItem';
import { DNDParentAsset } from '~/components/Shared/Drag/DNDParentAsset';
import DragType from '~/components/Shared/Drag/dragTypes';
import { DropHighlight } from '~/components/Shared/DropHighlight';
import { GalleryAsset, type GalleryAssetProps } from '~/components/v2/components/shared/gallery/GalleryAsset';

export type DNDGalleryAssetProps = {
  enableDrag?: boolean;
  index: number;
  onDragStart?: () => void;
} & GalleryAssetProps<Clip>;

export const DNDGalleryAsset = memo(
  ({ clip, enableDrag = true, index, onDragStart = noop, ...rest }: DNDGalleryAssetProps) => {
    return (
      <DNDMovableToBoardItem
        id={clip.id}
        enabled={enableDrag}
        item={{ type: DragType.asset, asset: clip, index, assetId: clip.assetId }}
        onDragStart={onDragStart}
        index={index}
      >
        <DNDParentAsset asset={clip} dropLocation="asset" style={{ height: '100%' }}>
          <DropHighlight borderRadius={18} />
          <GalleryAsset clip={clip} {...rest} />
          <DraggingOverlay itemId={clip.id} type={DragType.asset} />
        </DNDParentAsset>
      </DNDMovableToBoardItem>
    );
  },
);

DNDGalleryAsset.displayName = 'DNDGalleryAsset';
